import VehicleList from './styled';

export default VehicleList;
